import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class CertificateFile {
  constructor() {
    log.info('[INFO] Initialize Certificate File Module')
  }

  fetchAllCertificateFile(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params: {
          p: params.p,
          page_size: params.page_size,
          search: params.q,
        },
      }
    }

    return new Promise((resolve, reject) => {
      axios
        .get('v1/company/certificate/file/', parameters)
        .then(response => {
          log.debug('[DEBUG] Success to fetch certificate file')
          resolve(response.data)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch certificate file')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchCertificateFile(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/company/certificate/file/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch certificate file')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch certificate file')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateCertificateFile(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/company/certificate/file/${id}/`, data)
        .then(response => {
          log.debug('[DEBUG] Success to update certificate file')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update certificate file')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addCertificateFile(data) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/company/certificate/file/', data)
        .then(response => {
          log.debug('[DEBUG] Success to add certificate file')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add certificate file')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteCertificateFile(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/company/certificate/file/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete certificate file')
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete certificate file')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
